import { Star } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { Stagger, StaggerItem } from "@/components/Reveal";
import { IMG, TESTIMONIALS } from "@/data/site";

export default function Testimonials() {
  return (
    <div data-testid="testimonials-page">
      <PageHero overline="Testimonials" title="In our guests' words" subtitle="The truest measure of hospitality is what people say after they leave." image={IMG.pool2} />
      <section className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-12">
        <Stagger className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {TESTIMONIALS.map((t, i) => (
            <StaggerItem key={i}>
              <div className="bg-[#121212] border hairline p-8 h-full flex flex-col hover:border-[#d4af37]/40 transition-colors duration-500" data-testid={`testimonial-card-${i}`}>
                <div className="flex gap-1 mb-5">
                  {[...Array(t.rating)].map((_, s) => <Star key={s} size={15} className="fill-[#d4af37] text-[#d4af37]" />)}
                </div>
                <p className="font-serif-display italic text-lg text-white/85 leading-relaxed flex-1">"{t.text}"</p>
                <p className="mt-6 text-xs uppercase tracking-[0.25em] text-[#d4af37]">{t.name} — {t.origin}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </section>
    </div>
  );
}
